// ventesMobileApi.js — les deux endpoints dont l'écran Ventes mobile a besoin et
// qui ne figurent pas dans l'objet `api` de GestionVente.tsx. Tout le reste
// (liste, détail, articles, suppression/annulation/restauration) passe par cet
// objet `api`, afin de conserver le cache offline et la file d'attente hors-ligne.
import API_CONFIG from "../../config/api";

const BASE_URL = API_CONFIG.BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken");
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const scopeParams = ({ companyId, warehouseId }) => {
  const params = new URLSearchParams();
  if (companyId) params.set("company_id", String(companyId));
  if (warehouseId) params.set("warehouse_id", String(warehouseId));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

/** Paiements d'une vente (cf. VenteDetailModal.tsx:196-218). */
export async function fetchOrderPayments(orderId, scope = {}) {
  const res = await fetch(
    `${BASE_URL}/api/orders/${orderId}/payments${scopeParams(scope)}`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error(`Erreur ${res.status} lors du chargement des paiements`);

  const data = await res.json();
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.payments) ? data.payments : [];
}

/** Payload du ticket de caisse, attendu tel quel par TicketCaisse (GestionVente.tsx:4012-4041). */
export async function fetchOrderReceipt(orderId) {
  const res = await fetch(`${BASE_URL}/api/orders/${orderId}/receipt`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    let msg = "Erreur lors de la récupération du ticket de caisse";
    try {
      const parsed = JSON.parse(text);
      msg = parsed.message || parsed.error || parsed.details || msg;
    } catch {
      if (text) msg = text;
    }
    throw new Error(msg);
  }
  return res.json();
}
